import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { createInterest } from '../lib/api';
import { useToast } from '../hooks/use-toast';
import { Loader2 } from 'lucide-react';

const InterestModal = ({ open, onOpenChange, property }) => {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast({ title: 'Missing details', description: 'Please enter your name and phone.' });
      return;
    }
    setSubmitting(true);
    try {
      await createInterest({ property_id: property.id, ...form });
      toast({ title: 'Interest submitted!', description: 'Our team will get back to you shortly.' });
      setForm({ name: '', phone: '', email: '', message: '' });
      onOpenChange(false);
    } catch (err) {
      toast({ title: 'Submission failed', description: err.response?.data?.detail || 'Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-[#9a1b2f]">Interested in {property?.name}?</DialogTitle>
          <p className="text-xs text-gray-500">Fill in your details and our team will connect with you shortly.</p>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label htmlFor="name" className="text-xs">Name *</Label>
            <Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your full name" className="h-10" />
          </div>
          <div>
            <Label htmlFor="phone" className="text-xs">Phone *</Label>
            <Input id="phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 XXXXX XXXXX" className="h-10" />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs">Email (optional)</Label>
            <Input id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" className="h-10" />
          </div>
          <div>
            <Label htmlFor="message" className="text-xs">Message (optional)</Label>
            <Textarea id="message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={3} placeholder="I would like to know more about..." />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={submitting}>Cancel</Button>
            <Button type="submit" className="bg-[#9a1b2f] hover:bg-[#7a1524]" disabled={submitting}>
              {submitting && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Submit
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default InterestModal;
